<template>
    <nx-form :value="value"
             class="nx-scrollytelling-slide-editor-form"
             validation-mode="eager"
             v-on="$listeners"
             ref="form"
             v-slot="{ draft, form }">
      <nx-scrollytelling-slide-configuration-scope :draft="draft"/>
      <nx-form-scope-card title="Texto" icon="text_fields" collapsable>
        <v-layout row wrap>
          <v-flex xs12 sm6 :class="{ 'pr-4': $vuetify.breakpoint.smAndUp }">
            <nx-form-select
              name="textPosition"
              :label="$t('message.form.fields.textHorizontalPosition')"
              :items="textHorizontalPositionItems"
              validation="required"
              :value="draft.textPosition || 'center'"
            />
          </v-flex>
          <v-flex sm6></v-flex>
          <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
            <nx-form-color-picker
              name="textColor"
              :label="$t('message.form.fields.textColor')"
              default="000000"
              :value="draft.textColor"
            />
          </v-flex>
          <v-flex xs12 sm4 :class="{ 'pr-2 pl-2': $vuetify.breakpoint.smAndUp }">
            <nx-form-color-picker
              name="textBackgroundColor"
              :label="$t('message.scrollytelling.fields.textBackgroundColor')"
              :value="draft.textBackgroundColor"
            />
          </v-flex>
          <v-flex xs12 sm4 :class="{ 'pl-2': $vuetify.breakpoint.smAndUp }">
            <nx-form-select
              name="textBackgroundOpacityColor"
              :label="$t('message.scrollytelling.fields.textBackgroundOpacityColor')"
              :items="[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0]"
              :default="100"
              :value="draft.textBackgroundOpacityColor"
            />
          </v-flex>
        </v-layout>
      </nx-form-scope-card>
      <nx-form-scope-card title="Imagenes" icon="image" collapsable>
        <!-- v-flex xs12 md4>
          <nx-form-select
            name="multimediaOpacity"
            :label="$t('message.form.fields.multimediaOpacity')"
            :items="[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0]"
            :default="0"
            :value="draft.multimediaOpacity"
          />
        </v-flex -->
        <nx-scrollytelling-slide-multimedia-list
          name="multimedia"
          :value="draft.multimedia"
          include-rich-text
        />
      </nx-form-scope-card>
      <nx-scrollytelling-slide-background-color-scope :draft="draft" />
    </nx-form>
</template>

<script>
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxScrollytellingSlideConfigurationScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideConfigurationScope';
import NxForm from '@/modules/form/Form';
import NxScrollytellingSlideMultimediaList
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideMultimediaList';
import NxScrollytellingSlideBackgroundColorScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideBackgroundColorScope';
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';
import NxFormSelect from '@/modules/form/components/FormSelect';

export default {
  name: 'nx-scrollytelling-slide-editor-form-parallax-image',
  components: {
    NxScrollytellingSlideBackgroundColorScope,
    NxScrollytellingSlideMultimediaList,
    NxForm,
    NxScrollytellingSlideConfigurationScope,
    NxFormScopeCard,
    NxFormColorPicker,
    NxFormSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    textHorizontalPositionItems() {
      return [
        {
          text: this.$t('message.common.left'),
          value: 'left',
        },
        {
          text: this.$t('message.common.center'),
          value: 'center',
        },
        {
          text: this.$t('message.common.right'),
          value: 'right',
        },
      ];
    },
  },
};
</script>
